import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { AddLetterPopupComponent } from 'src/app/shared/popups/add-letter-popup/add-letter-popup.component';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { saveAs } from 'file-saver';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-increment-letter',
  templateUrl: './increment-letter.component.html',
  styleUrls: ['./increment-letter.component.scss'],
})
export class IncrementLetterComponent implements OnInit {
  buttonColorName: any;
  fileName: any = null;
  fileType: any = null;
  formData: any = new FormData();
  loggedInUserCompanyID: any;
  selectedYear: any;
  companyYears: any[] = [];
  fromYear: any;
  toYear: any;
  loggedInCompanyFiscalyear: any;
  letterHeadUrl: any;
  isDisabled: boolean = false;

  departmentChecked: any = false;
  ratingChecked: any = false;
  bandChecked: any = false;
  onVisibleDepartmentData: any = false;
  onVisibleBandData: any = false;
  onVisibleRatingsData: any = false;
  onVisibleDepartmentAndBandData: any = false;
  onVisibleDepartmentAndRatingData: any = false;
  onVisibleBandAndRatingData: any = false;
  onVisibleDepartmentAndBandAndRatingData: any = false;
  isShowNoLetterFound: any = false;

  isIncrementLetterCreateContent: any = false
  showBrowseBtn: boolean = false;
  isDisabledLetterHeadBtn: boolean = true;
  IncrementLetterPromotionContent: any;
  getIncrementFyYearList: any[] = [];
  getDepartmentTableData: any[] = [];
  getBandTableData: any[] = [];
  getDepartmentAndBandTableData: any[] = []
  getRatingAndDeptTableData: any[] = [];
  getDeptAndRatingTableData: any[] = [];
  getBandAndRatingTableData: any[] = [];
  getRatingAndBandTableData: any[] = [];
  getRatingTableData: any[] = [];
  incrementId: any;
  letterNames: any[] = [];
  getIncrementLetterData: any[] = []
  private letterDataMap: { [letterName: string]: any } = {};
  isInValidIncrementLetterDescription: any = false;
  isDisabledIncrementLetter: any = false;
  isDisabledImportLetter:any;


  constructor(public dialog: MatDialog, private router: Router, private config: Config,
    private httpService: HttpService, private encryptionService: EncryptionService,
    private loader: LoaderService, public sharedService: SharedService,
  ) { }

  ngOnInit() {
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
  }

  ionViewWillEnter() {
    this.getIncrementFyYear();
  }

  getIncrementFyYear() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "fromYear": null,
      "toYear": null
    }
    this.httpService.callPostService(this.config.getOverallBudgetGrid, request).subscribe((result: any) => {
      this.getIncrementFyYearList = result.data.map((ele: any) => ({
        year: `${ele.fromYear}-${ele.toYear}`,
      }));

      const currentYear = new Date().getFullYear();
      const currentDate = new Date();
      const currentMonth = currentDate.getMonth(); 
      let yearValue = '';
      if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
        yearValue = `${currentYear}-${currentYear}`;
      } else {
        yearValue = `${currentYear}-${currentYear + 1}`;
        if(this.loggedInCompanyFiscalyear === 'Apr_Mar'){
          if(currentMonth<3){
            yearValue = `${currentYear-1}-${currentYear}`;
          }else{
            yearValue = `${currentYear}-${currentYear + 1}`;
          }
        }
        if(this.loggedInCompanyFiscalyear === 'July_Jun'){
          if(currentMonth<6){
            yearValue = `${currentYear-1}-${currentYear}`;
          }else{
            yearValue = `${currentYear}-${currentYear + 1}`;
          }
        }
        if(this.loggedInCompanyFiscalyear === 'Oct_Sep'){
          if(currentMonth<9){
            yearValue = `${currentYear-1}-${currentYear}`;
          }else{
            yearValue = `${currentYear}-${currentYear + 1}`;
          }
        }
      }

      let selectedYearIndex = this.getIncrementFyYearList.findIndex((ele: any) => ele?.year === yearValue);
      if (selectedYearIndex === -1) {
        selectedYearIndex = 0;
      }
      this.selectedYear = this.getIncrementFyYearList[selectedYearIndex]?.year;
      var test = this.selectedYear?.split('-');
      this.fromYear = test[0];
      this.toYear = test[1];

      this.getMDApprovedData();
      this.isLetterHeadUploaded();
      this.getIncrementLettersCompanyData();
    })
  }

  onYearChange(selectedYear: any) {
    var selectedYearArray = selectedYear.value.split('-');
    this.fromYear = selectedYearArray[0];
    this.toYear = selectedYearArray[1];
    this.getMDApprovedData();
    this.isLetterHeadUploaded();
    this.getIncrementLettersCompanyData();
  }


  // onYearChange(event: any) {
  //   this.updateYearRange(event.value);
  // }

  onClickSetup(operation: any) {
    this.router.navigate(['/home/hrportal/increment', { operation: operation }]);
  }

  // getIncrementSetupByYear() {
  //   const request = {
  //     "companyId": this.loggedInUserCompanyID,
  //     "fromYear": this.fromYear,
  //     "toYear": this.toYear
  //   }
  //   this.httpService.callPostService(this.config.getIncrementSetupByYear, request).subscribe((result: any) => {
  //     this.incrementId = result.data.id
  //   })
  // }

  getAllIncrementLetterFormat() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "fromYear": this.fromYear,
      "toYear": this.toYear
    }
    this.httpService.callPostService(this.config.getAllIncrementLetterFormatOfCompany, request).subscribe((result) => { })
  }

  getMDApprovedData() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "fromYear": this.fromYear,
      "toYear": this.toYear
    }
    this.httpService.callPostService(this.config.getIncrementApprovalDataOfCompany, request).subscribe((result: any) => {
      if (result.data?.mdReviewStatus == "Approved") {
        this.isDisabledIncrementLetter = true;
        this.isDisabledImportLetter = false;
      }
      else if (result.data?.mdReviewStatus == "Rejected") {
        this.isDisabledIncrementLetter = false;
        this.isDisabledImportLetter = true;
      }
      else {
        this.isDisabledIncrementLetter = false;
        this.isDisabledImportLetter = true;
      }
    })
  }

  isLetterHeadUploaded() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "fromYear": this.fromYear,
      "toYear": this.toYear
    }
    this.httpService.callPostService(this.config.getIncrementSetupByYear, request).subscribe((result: any) => {    
      if(result.data.letterHeadFileName == null){
        this.showBrowseBtn = false;
      }else{
        this.showBrowseBtn = true;
      }
      this.fileName = result.data?.letterHeadFileName;
    })
  }

  onMenuClose() {
    // Optional: Handle any cleanup when the menu is closed
  }

  selectImportDWMFile(event: any) {
    this.showBrowseBtn = true;
  }

  onClickDone() {

  }

  onFileSelected(event: Event) {
    const inputEvent: any = event.target as HTMLInputElement;
    this.fileName = null;
    this.fileType = null;
    this.formData = new FormData();
    if (!inputEvent.files || inputEvent.files.length === 0) {
      return;
    }
    const file = inputEvent.files[0];
    const fileSizeInKB = file.size / 1024;
    const fileSizeInMB = fileSizeInKB / 1024;
    const allowedExtensions = ['.pdf'];
    const fileNameLowerCase = file.name.toLowerCase();
    const isAllowedFormat = allowedExtensions.some(ext => fileNameLowerCase.endsWith(ext));
  
    if (!isAllowedFormat) {
      window.alert("Only PDF files are allowed.");
      return;
    }
    if (fileSizeInMB > 10) {
      window.alert("File size is greater than 10MB");
      return;
    }
    this.fileName = file.name;
    this.fileType = file.type;
    this.formData = new FormData();
    this.formData.append('file', file);
    this.formData.append('companyId', this.loggedInUserCompanyID);
    this.showBrowseBtn = true;
    this.isDisabledLetterHeadBtn = false;
  
    const url = this.config.uploadFileLocally + `?fileName=${this.fileName}&fileType=${this.fileType}`;
    this.httpService.submitFormService(url, this.formData).subscribe((data: any) => {
      this.letterHeadUrl = data?.data;
    });
  }
  

  onCloseFile() {
    this.showBrowseBtn = false;
    this.isDisabledLetterHeadBtn = true;
  }

  onSendCompanyLetterheadFile() {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: 'Are you sure to upload Increment letter',
        btn1: 'Cancel',
        btn2: 'Yes',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      const payload = {
        "fromYear": this.fromYear,
        "toYear": this.toYear,
        "companyId": this.loggedInUserCompanyID,
        "letterHeadUrl": this.letterHeadUrl,
        "letterHeadUrlName": this.fileName
      };
      this.httpService.callPostService(this.config.uploadLetterHead, payload).subscribe((result: any) => {
        this.showBrowseBtn = true;
        this.isDisabledLetterHeadBtn = true;
        this.isLetterHeadUploaded();
      })
    })
  }

  onClickDownloadLetterHeadFile() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "fromYear": this.fromYear,
      "toYear": this.toYear
    }
    this.httpService.callPostService(this.config.getIncrementSetupByYear, request).subscribe((result: any) => {
      const downloadFile: any = result.data;
      if (downloadFile.letterHeadUrl) {
        var fileName = downloadFile.letterHeadUrl.split(environment.downloadURL)
        saveAs(downloadFile.letterHeadUrl, fileName[1]);
      }
      // saveAs(environment.downloadURL + result?.data?.letterHeadUrl, result?.data?.letterHeadUrl);
    })
  }

  getIncrementLettersCombination() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "fromYear": this.fromYear,
      "toYear": this.toYear
    }
    this.httpService.callPostService(this.config.getIncrementLettersCombination, request).subscribe((result: any) => {
    })
  }

  onClickCreateBtn() {
    // only department
    if (this.departmentChecked && !this.bandChecked && !this.ratingChecked) {
      const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
        disableClose: true,
        height: '25%',
        width: '30%',
        data: {
          msg: 'Are you sure you want to select only department',
          btn1: 'Cancel',
          btn2: 'Yes',
          btn2BgColor: this.buttonColorName,
          showSuccessIcon: false,
          showSuccessMessage: false,
          showCloseIcon: false
        },
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          sessionStorage.removeItem('LettersName');
          this.getIncrementLetterData = [];
          setTimeout(() => {
            this.isIncrementLetterCreateContent = true;
            this.onVisibleDepartmentData = true;
            this.onVisibleBandData = false;
            this.onVisibleDepartmentAndBandData = false;
            this.onVisibleDepartmentAndRatingData = false;
            this.onVisibleBandAndRatingData = false;
            this.onVisibleDepartmentAndBandAndRatingData = false;
            this.onVisibleRatingsData = false;
            this.letterNames = [];
            const request = {
              "companyId": this.loggedInUserCompanyID,
              "fetchBand": false,
              "fetchDepartment": true,
              "fromYear": this.fromYear,
              "toYear": this.toYear
            };
            this.httpService.callPostService(this.config.getIncrementLettersCombination, request).subscribe((result: any) => {
              this.getDepartmentTableData = result.data
            });
          }, 200);
        }
      });
    }

    // only band
    if (this.bandChecked && !this.departmentChecked && !this.ratingChecked) {
      const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
        disableClose: true,
        height: '25%',
        width: '30%',
        data: {
          msg: 'Are you sure you want to select only band',
          btn1: 'Cancel',
          btn2: 'Yes',
          btn2BgColor: this.buttonColorName,
          showSuccessIcon: false,
          showSuccessMessage: false,
          showCloseIcon: false
        },
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          sessionStorage.removeItem('LettersName');
          this.getIncrementLetterData = [];
          setTimeout(() => {
            this.isIncrementLetterCreateContent = true;
            this.onVisibleDepartmentData = false;
            this.onVisibleBandData = true;
            this.onVisibleDepartmentAndBandData = false;
            this.onVisibleDepartmentAndRatingData = false;
            this.onVisibleBandAndRatingData = false;
            this.onVisibleDepartmentAndBandAndRatingData = false;
            this.onVisibleRatingsData = false;
            this.letterNames = [];
            const request = {
              "companyId": this.loggedInUserCompanyID,
              "fetchBand": true,
              "fetchDepartment": false,
              "fromYear": this.fromYear,
              "toYear": this.toYear
            };
            this.httpService.callPostService(this.config.getIncrementLettersCombination, request).subscribe((result: any) => {
              this.getBandTableData = result.data;
            });
          }, 200);
        }
      });
    }

    // only rating
    if (this.ratingChecked && !this.departmentChecked && !this.bandChecked) {
      const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
        disableClose: true,
        height: '25%',
        width: '30%',
        data: {
          msg: 'Are you sure you want to select only rating',
          btn1: 'Cancel',
          btn2: 'Yes',
          btn2BgColor: this.buttonColorName,
          showSuccessIcon: false,
          showSuccessMessage: false,
          showCloseIcon: false
        },
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          sessionStorage.removeItem('LettersName');
          this.getIncrementLetterData = [];
          setTimeout(() => {
            this.isIncrementLetterCreateContent = true;
            this.onVisibleDepartmentData = false;
            this.onVisibleBandData = false;
            this.onVisibleDepartmentAndBandData = false;
            this.onVisibleDepartmentAndRatingData = false;
            this.onVisibleBandAndRatingData = false;
            this.onVisibleDepartmentAndBandAndRatingData = false;
            this.onVisibleRatingsData = true;
            this.letterNames = [];
            const request = {
              "companyId": this.loggedInUserCompanyID,
              "fromYear": this.fromYear,
              "toYear": this.toYear
            }
            this.httpService.callPostService(this.config.getScoreToRatingConverter, request).subscribe((result: any) => {
              this.getRatingTableData = result.data.map((ele: any) => ({
                rating: ele.rating,
                ratingId: ele.id,
              }));
            })
          }, 200);
        }
      });
    }

    // department and band
    if (this.departmentChecked && this.bandChecked && !this.ratingChecked) {
      const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
        disableClose: true,
        height: '25%',
        width: '30%',
        data: {
          msg: 'Are you sure you want to select only department and band',
          btn1: 'Cancel',
          btn2: 'Yes',
          btn2BgColor: this.buttonColorName,
          showSuccessIcon: false,
          showSuccessMessage: false,
          showCloseIcon: false
        },
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          sessionStorage.removeItem('LettersName');
          this.getIncrementLetterData = [];
          setTimeout(() => {
            this.isIncrementLetterCreateContent = true;
            this.onVisibleDepartmentData = false;
            this.onVisibleBandData = false;
            this.onVisibleDepartmentAndBandData = true;
            this.onVisibleDepartmentAndRatingData = false;
            this.onVisibleBandAndRatingData = false;
            this.onVisibleDepartmentAndBandAndRatingData = false;
            this.onVisibleRatingsData = false;
            this.letterNames = [];
            const request = {
              "companyId": this.loggedInUserCompanyID,
              "fetchBand": true,
              "fetchDepartment": true,
              "fromYear": this.fromYear,
              "toYear": this.toYear
            };
            this.httpService.callPostService(this.config.getIncrementLettersCombination, request).subscribe((result: any) => {
              this.getDepartmentAndBandTableData = result.data;
              this.onVisibleDepartmentAndBandAndRatingData = false;
            });
          }, 200);
        }
      });
    }

    // department and rating
    if (this.departmentChecked && this.ratingChecked && !this.bandChecked) {
      const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
        disableClose: true,
        height: '25%',
        width: '30%',
        data: {
          msg: 'Are you sure you want to select only department and rating',
          btn1: 'Cancel',
          btn2: 'Yes',
          btn2BgColor: this.buttonColorName,
          showSuccessIcon: false,
          showSuccessMessage: false,
          showCloseIcon: false
        },
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          sessionStorage.removeItem('LettersName');
          this.getIncrementLetterData = [];
          setTimeout(() => {
            this.isIncrementLetterCreateContent = true;
            this.onVisibleDepartmentData = false;
            this.onVisibleBandData = false;
            this.onVisibleDepartmentAndBandData = false;
            this.onVisibleDepartmentAndRatingData = true;
            this.onVisibleBandAndRatingData = false;
            this.onVisibleDepartmentAndBandAndRatingData = false;
            this.onVisibleRatingsData = false;
            this.letterNames = [];

            const getdepartmentrequest = {
              "companyId": this.loggedInUserCompanyID,
              "fetchBand": false,
              "fetchDepartment": true,
              "fromYear": this.fromYear,
              "toYear": this.toYear
            };
            this.httpService.callPostService(this.config.getIncrementLettersCombination, getdepartmentrequest).subscribe((result: any) => {
              this.getDepartmentTableData = result.data
            });

            const getRatingrequest = {
              "companyId": this.loggedInUserCompanyID,
              "fromYear": this.fromYear,
              "toYear": this.toYear
            }
            this.httpService.callPostService(this.config.getScoreToRatingConverter, getRatingrequest).subscribe((result: any) => {
              this.getRatingTableData = result.data.map((ele: any) => ({
                rating: ele.rating,
                ratingId: ele.id,
              }));
            })
          }, 200);
        }
      });
    }

    // band and rating
    if (this.bandChecked && this.ratingChecked && !this.departmentChecked) {
      const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
        disableClose: true,
        height: '25%',
        width: '30%',
        data: {
          msg: 'Are you sure you want to select only band and rating',
          btn1: 'Cancel',
          btn2: 'Yes',
          btn2BgColor: this.buttonColorName,
          showSuccessIcon: false,
          showSuccessMessage: false,
          showCloseIcon: false
        },
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          sessionStorage.removeItem('LettersName');
          this.getIncrementLetterData = [];
          setTimeout(() => {
            this.isIncrementLetterCreateContent = true;
            this.onVisibleDepartmentData = false;
            this.onVisibleBandData = false;
            this.onVisibleDepartmentAndBandData = false;
            this.onVisibleDepartmentAndRatingData = false;
            this.onVisibleBandAndRatingData = true;
            this.onVisibleDepartmentAndBandAndRatingData = false;
            this.onVisibleRatingsData = false;
            this.letterNames = [];

            const getBandrequest = {
              "companyId": this.loggedInUserCompanyID,
              "fetchBand": true,
              "fetchDepartment": false,
              "fromYear": this.fromYear,
              "toYear": this.toYear
            };
            this.httpService.callPostService(this.config.getIncrementLettersCombination, getBandrequest).subscribe((result: any) => {
              this.getBandAndRatingTableData = result.data;
            });

            const getRatingrequest = {
              "companyId": this.loggedInUserCompanyID,
              "fromYear": this.fromYear,
              "toYear": this.toYear
            }
            this.httpService.callPostService(this.config.getScoreToRatingConverter, getRatingrequest).subscribe((result: any) => {
              this.getRatingAndBandTableData = result.data.map((ele: any) => ({
                rating: ele.rating,
                ratingId: ele.id,
              }));
            })
          }, 200);
        }
      });
    }

    // department and band and rating
    if (this.departmentChecked && this.bandChecked && this.ratingChecked) {
      const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
        disableClose: true,
        height: '25%',
        width: '30%',
        data: {
          msg: 'Are you sure you want to select only department, band and rating',
          btn1: 'Cancel',
          btn2: 'Yes',
          btn2BgColor: this.buttonColorName,
          showSuccessIcon: false,
          showSuccessMessage: false,
          showCloseIcon: false
        },
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          sessionStorage.removeItem('LettersName');
          this.getIncrementLetterData = [];
          setTimeout(() => {
            this.isIncrementLetterCreateContent = true;
            this.onVisibleDepartmentData = false;
            this.onVisibleBandData = false;
            this.onVisibleDepartmentAndBandData = false;
            this.onVisibleDepartmentAndRatingData = false;
            this.onVisibleBandAndRatingData = false;
            this.onVisibleDepartmentAndBandAndRatingData = true;
            this.onVisibleRatingsData = false;
            this.letterNames = [];
            const request = {
              "companyId": this.loggedInUserCompanyID,
              "fetchBand": true,
              "fetchDepartment": true,
              "fromYear": this.fromYear,
              "toYear": this.toYear
            };
            this.httpService.callPostService(this.config.getIncrementLettersCombination, request).subscribe((result: any) => {
              this.getDepartmentAndBandTableData = result.data;
            });

            const getRatingrequest = {
              "companyId": this.loggedInUserCompanyID,
              "fromYear": this.fromYear,
              "toYear": this.toYear
            }
            this.httpService.callPostService(this.config.getScoreToRatingConverter, getRatingrequest).subscribe((result: any) => {
              this.getRatingTableData = result.data.map((ele: any) => ({
                rating: ele.rating,
                ratingId: ele.id,
              }));
            })
          }, 200);
        }
      });
    }
    if (!this.departmentChecked && !this.bandChecked && !this.ratingChecked) {
      this.onVisibleDepartmentData = false;
      this.onVisibleBandData = false;
      this.onVisibleDepartmentAndBandData = false;
      this.onVisibleRatingsData = false;
      this.onVisibleDepartmentAndBandAndRatingData = false;
    }
    this.getPromotionContent();
  }

  // onClickAddLetter(rowId: number, colId?: number) {
  //   const columnId = colId || 0;
  //   const existingLetterName = this.letterNames[rowId] ? this.letterNames[rowId][columnId] : null;

  //   // Retrieve subject and body from letterDataMap if the letterName exists
  //   const letterData = existingLetterName ? this.letterDataMap[existingLetterName] : { subject: '', body: '' };

  //   const dialogConfig = new MatDialogConfig();
  //   dialogConfig.height = '70%';
  //   dialogConfig.width = '100%';
  //   dialogConfig.data = {
  //     rowID: rowId,
  //     columnID: columnId,
  //     existingLetterName: existingLetterName,
  //     subject: letterData.subject,   // Pass the subject to the dialog
  //     body: letterData.body,         // Pass the body to the dialog
  //     letterDataMap: this.letterDataMap
  //   };
  //   dialogConfig.panelClass = 'custom-dialog-container';

  //   const dialogRef = this.dialog.open(AddLetterPopupComponent, dialogConfig);
  //   dialogRef.afterClosed().subscribe(result => {   
  //     if (result) {
  //       const { letterName, subject, body } = result;
  //       if (!this.letterNames[rowId]) {
  //         this.letterNames[rowId] = [];
  //       }
  //       this.letterNames[rowId][columnId] = letterName;

  //       // Update letterDataMap with the latest subject and body for the letterName
  //       this.letterDataMap[letterName] = { subject, body };

  //       const existingIndex = this.getIncrementLetterData.findIndex(
  //         data => data.rowId === rowId && data.colId === columnId
  //       );

  //       if (existingIndex !== -1) {
  //         this.getIncrementLetterData[existingIndex] = {
  //           rowId: rowId,
  //           colId: columnId,
  //           letterName: letterName,
  //           subject: subject,
  //           body: body
  //         };
  //       } else {
  //         this.getIncrementLetterData.push({
  //           rowId: rowId,
  //           colId: columnId,
  //           letterName: letterName,
  //           subject: subject,
  //           body: body
  //         });
  //       }      
  //     }
  //   });
  // }

  onClickAddLetter(rowId: any, colId: any, department: any, band: any, ratingId: any, letterName: any) {
    let letterNameArray: any = [];
    const lettersName = sessionStorage.getItem('LettersName');
    if (lettersName) {
      letterNameArray = JSON.parse(lettersName);
      const index = letterNameArray.indexOf(letterName?.toString());
      if (index !== -1) {
        letterNameArray.splice(index, 1);
        sessionStorage.setItem('LettersName', JSON.stringify(letterNameArray));
      }
    }
    const columnId = colId || 0;
    const existingLetterName = this.letterNames[rowId] ? this.letterNames[rowId][columnId] : null;
    const letterData = existingLetterName ? this.letterDataMap[existingLetterName] : { subject: '', body: '' };
    const bandData = this.getBandTableData[rowId];
    const dialogConfig = new MatDialogConfig();
    dialogConfig.height = '70%';
    dialogConfig.width = '100%';
    dialogConfig.data = {
      rowID: rowId,
      columnID: columnId,
      existingLetterName: existingLetterName || null,
      subject: letterData.subject || null,
      body: letterData.body || null,
      letterDataMap: this.letterDataMap || null,
      department: department || null,
      band: band || null,
      ratingId: ratingId || null,
      isMDApprove: this.isDisabledIncrementLetter
    };
    dialogConfig.panelClass = 'custom-dialog-container';
    const dialogRef = this.dialog.open(AddLetterPopupComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const { letterName, subject, body } = result;
        if (!this.letterNames[rowId]) {
          this.letterNames[rowId] = [];
        }
        this.letterNames[rowId][columnId] = letterName;
        this.letterDataMap[letterName] = { subject, body };
        const existingIndex = this.getIncrementLetterData.findIndex(
          data => data.rowId === rowId && data.colId === columnId
        );
        if (existingIndex !== -1) {
          this.getIncrementLetterData[existingIndex] = {
            rowId: rowId,
            colId: columnId,
            letterName: letterName,
            subject: subject,
            body: body
          };
        } else {
          this.getIncrementLetterData.push({
            rowId: rowId,
            colId: columnId,
            letterName: letterName,
            subject: subject,
            body: body
          });
        }
      }
    });
  }

  onClickAddDeptBandRatingLetter(rowId: any, bandRowId: any, colId: any, department: any, band: any, ratingId: any, letterName: any) {
    let letterNameArray: any = [];
    const lettersName = sessionStorage.getItem('LettersName');
    if (lettersName) {
      letterNameArray = JSON.parse(lettersName);
      const index = letterNameArray.indexOf(letterName?.toString());
      if (index !== -1) {
        letterNameArray.splice(index, 1);
        sessionStorage.setItem('LettersName', JSON.stringify(letterNameArray));
      }
    }
    const columnId = colId || 0;
    if (!this.letterNames[rowId]) {
      this.letterNames[rowId] = [];
    }
    if (!this.letterNames[rowId][bandRowId]) {
      this.letterNames[rowId][bandRowId] = [];
    }
    const existingLetterName = this.letterNames[rowId][bandRowId][columnId] || null;
    const letterData = existingLetterName ? this.letterDataMap[existingLetterName] : { subject: '', body: '' };
    const dialogConfig = new MatDialogConfig();
    dialogConfig.height = '70%';
    dialogConfig.width = '100%';
    dialogConfig.data = {
      rowID: rowId,
      bandRowId: bandRowId,
      columnID: columnId,
      existingLetterName: existingLetterName || null,
      subject: letterData.subject || null,
      body: letterData.body || null,
      letterDataMap: this.letterDataMap || null,
      department: department || null,
      band: band || null,
      ratingId: ratingId || null
    };
    dialogConfig.panelClass = 'custom-dialog-container';
    const dialogRef = this.dialog.open(AddLetterPopupComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const { letterName, subject, body } = result;
        if (!this.letterNames[rowId]) {
          this.letterNames[rowId] = [];
        }
        if (!this.letterNames[rowId][bandRowId]) {
          this.letterNames[rowId][bandRowId] = [];
        }
        this.letterNames[rowId][bandRowId][columnId] = letterName;
        this.letterDataMap[letterName] = { subject, body };
        const existingIndex = this.getIncrementLetterData.findIndex(
          data => data.rowId === rowId && data.colId === columnId
        );
        if (existingIndex !== -1) {
          this.getIncrementLetterData[existingIndex] = {
            rowId: rowId,
            colId: columnId,
            letterName: letterName,
            subject: subject,
            body: body
          };
        } else {
          this.getIncrementLetterData.push({
            rowId: rowId,
            colId: columnId,
            letterName: letterName,
            subject: subject,
            body: body
          });
        }
      }
    });
  }


  selectLetter(rowId: number, letter: any) {
    if (this.isDisabledIncrementLetter != true) {
      if (!this.letterNames[rowId]) {
        this.letterNames[rowId] = [];
      }
      this.letterNames[rowId][0] = letter.letterName;
    }
  }

  selectRatingLetter(rowId: number, colId: number, letter: any) {
    if (this.isDisabledIncrementLetter != true) {
      if (!this.letterNames[rowId]) {
        this.letterNames[rowId] = [];
      }
      this.letterNames[rowId][colId] = letter.letterName;
    }
  }

  selectDeptAndBandAndRatingLetter(rowId: number, rowIndexId: number, colId: number, letter: any) {
    if (this.isDisabledIncrementLetter !== true) {
      if (!this.letterNames[rowId]) {
        this.letterNames[rowId] = [];
      }
      if (!this.letterNames[rowId][rowIndexId]) {
        this.letterNames[rowId][rowIndexId] = [];
      }
      this.letterNames[rowId][rowIndexId][colId] = letter.letterName;
    }
  }

  // selectRatingLetter(rowId: number, colId: number, letter: any) {
  //   if (!this.letterNames[rowId]) this.letterNames[rowId] = [];
  //   this.letterNames[rowId][colId] = letter.letterName;
  // }

  // IncrementLetterDescription(){
  //   if(this.IncrementLetterPromotionContent == undefined){
  //     this.isInValidIncrementLetterDescription = true;
  //    }else{
  //     this.isInValidIncrementLetterDescription = false;
  //    }
  // }

  onClickCancleBtn() {
    this.isIncrementLetterCreateContent = false;
    this.departmentChecked = false;
    this.bandChecked = false;
    this.ratingChecked = false;
    this.letterNames = [];
  }
  updateLetterId: any[] = [];
  letterCombination: any;

  // onCLickLetterSave(letterName:any, subject:any, body:any, department:any, band:any, ratindId:any, id:any){  
  //   if (this.departmentChecked && !this.bandChecked && !this.ratingChecked) {
  //     this.letterCombination = 0
  //   }
  //   if (!this.departmentChecked && this.bandChecked && !this.ratingChecked) {
  //     this.letterCombination = 1
  //   }
  //   if (!this.departmentChecked && !this.bandChecked && this.ratingChecked) {
  //     this.letterCombination = 2
  //   }
  //   if (this.departmentChecked && this.bandChecked && !this.ratingChecked) {
  //     this.letterCombination = 3
  //   }
  //   if (this.departmentChecked && this.ratingChecked && !this.bandChecked) {
  //     this.letterCombination = 4
  //   }
  //   if (this.bandChecked && this.ratingChecked && !this.departmentChecked) {
  //     this.letterCombination = 5
  //   }
  //   if (this.bandChecked && this.ratingChecked && this.departmentChecked) {
  //     this.letterCombination = 6
  //   }
  //   const dialogConfig = new MatDialogConfig();
  //   dialogConfig.height = '70%';
  //   dialogConfig.width = '100%';
  //   dialogConfig.data = {
  //     letterName:letterName,
  //     subject:subject,
  //     body:body,
  //     department:department,
  //     band:band,
  //     ratindId:ratindId,
  //     id:id,
  //     letterCombination: this.letterCombination
  //   };
  //   dialogConfig.panelClass = 'custom-dialog-container';
  //   const dialogRef = this.dialog.open(AddLetterPopupComponent, dialogConfig);
  //   dialogRef.afterClosed().subscribe(result => {
  //     if(result){
  //       this.getIncrementLettersCompanyData()
  //     }
  //   })
  // }

  onClickIncrementLetterSave() {
    this.getIncrementLetterData = [];
    if (this.IncrementLetterPromotionContent == undefined) {
      this.isInValidIncrementLetterDescription = true;
    } else {
      this.isInValidIncrementLetterDescription = false;

      // only Departmnet
      if (this.departmentChecked && !this.bandChecked && !this.ratingChecked) {
        const departmentLetterData: any[] = [];
        let allLettersSelected = true;
        this.getDepartmentTableData.forEach((departmentName: string, rowId: number) => {
          const lettersForDepartment = this.letterNames[rowId];

          if (!lettersForDepartment || lettersForDepartment.length === 0) {
            allLettersSelected = false;
          } else {
            lettersForDepartment.forEach((letterName: string) => {
              if (letterName) {
                const letterData = this.letterDataMap[letterName];
                departmentLetterData.push({
                  band: null,
                  companyId: this.loggedInUserCompanyID,
                  department: departmentName,
                  fromYear: this.fromYear,
                  id: null,
                  // id: letterData.id || null,
                  letterCombination: 0,
                  letterTemplateRequest: {
                    body: letterData.body,
                    letterName: letterName,
                    subject: letterData.subject
                  },
                  ratingId: null,
                  toYear: this.toYear
                });
              } else {
                allLettersSelected = false;
              }
            });
          }
        });

        // Confirmation popup before sending the data
        const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
          disableClose: true,
          height: '30%',
          width: '30%',
          data: {
            msg: 'Increment letter successfully saved.',
            btn2: 'Done',
            btn2BgColor: this.buttonColorName,
            showSuccessIcon: false,
            showSuccessMessage: false,
            showCloseIcon: false
          }
        });

        dialogRef.afterClosed().subscribe((result: any) => {
          if (result) {
            this.httpService.callPostService(this.config.setIncrementLettersForCombination, departmentLetterData).subscribe((result: any) => {
              if (result) {
                sessionStorage.removeItem('LettersName');
                this.getIncrementLettersCompanyData();
                this.getPromotionContent();
              }
            });
          }
        });
      }


      // only Band
      if (!this.departmentChecked && this.bandChecked && !this.ratingChecked) {
        const BandLetterData: any = [];
        let allLettersSelected = true;
        this.getBandTableData.forEach((BandName: string, rowId: number) => {
          const lettersForBand = this.letterNames[rowId];
          if (!lettersForBand || lettersForBand.length === 0) {
            allLettersSelected = false;
          } else {
            lettersForBand.forEach((letterName: string) => {
              if (letterName) {
                const letterData = this.letterDataMap[letterName];
                BandLetterData.push({
                  band: BandName,
                  companyId: this.loggedInUserCompanyID,
                  department: null,
                  fromYear: this.fromYear,
                  id: null,
                  letterCombination: 1,
                  letterTemplateRequest: {
                    body: letterData.body,
                    letterName: letterName,
                    subject: letterData.subject,
                  },
                  ratingId: null,
                  toYear: this.toYear
                });
              } else {
                allLettersSelected = false;
              }
            });
          }
        });
        // if (allLettersSelected && BandLetterData.length > 0) {
        const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
          disableClose: true,
          height: '30%',
          width: '30%',
          data: {
            msg: 'Increment letter successfully saved.',
            btn2: 'Done',
            btn2BgColor: this.buttonColorName,
            showSuccessIcon: false,
            showSuccessMessage: false,
            showCloseIcon: false
          },
        });
        dialogRef.afterClosed().subscribe((result: any) => {
          this.httpService.callPostService(this.config.setIncrementLettersForCombination, BandLetterData)
            .subscribe((result: any) => {
              if (result) {
                sessionStorage.removeItem('LettersName');
                this.getIncrementLettersCompanyData();
                this.getPromotionContent();
              }
            });
        })
        // } else {
        //   window.alert("Please select all letters before proceeding.");
        // }
      }

      // only rating
      if (!this.departmentChecked && !this.bandChecked && this.ratingChecked) {
        const payload: any[] = [];
        let allLettersSelected = true;
        this.getRatingTableData.forEach((rating: any, colId: number) => {
          const lettersForRating = this.letterNames[0] && this.letterNames[0][colId] ? [this.letterNames[0][colId]] : [];
          if (!lettersForRating || lettersForRating.length === 0) {
            allLettersSelected = false;
          } else {
            lettersForRating.forEach((letterName: string) => {
              if (letterName) {
                const letterData = this.letterDataMap[letterName];
                payload.push({
                  band: null,
                  companyId: this.loggedInUserCompanyID,
                  department: null,
                  fromYear: this.fromYear,
                  id: null,
                  letterCombination: 2,
                  letterTemplateRequest: {
                    body: letterData.body,
                    letterName: letterName,
                    subject: letterData.subject,
                  },
                  ratingId: rating.ratingId,
                  toYear: this.toYear
                });
              } else {
                allLettersSelected = false;
              }
            });
          }
        });

        // if (allLettersSelected && BandLetterData.length > 0) {
        const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
          disableClose: true,
          height: '30%',
          width: '30%',
          data: {
            msg: 'Increment letter successfully saved.',
            btn2: 'Done',
            btn2BgColor: this.buttonColorName,
            showSuccessIcon: false,
            showSuccessMessage: false,
            showCloseIcon: false
          },
        });
        dialogRef.afterClosed().subscribe((result: any) => {
          this.httpService.callPostService(this.config.setIncrementLettersForCombination, payload)
            .subscribe((result: any) => {
              if (result) {
                sessionStorage.removeItem('LettersName');
                this.getIncrementLettersCompanyData();
                this.getPromotionContent();
              }
            });
        })
      }


      // department and band
      if (this.departmentChecked && this.bandChecked && !this.ratingChecked) {
        const payload: any[] = [];
        let allLettersSelected: boolean = true;

        this.getDepartmentAndBandTableData.forEach((departmentData, rowId) => {
          departmentData.bands.forEach((band: any, colId: number) => {
            const letterName =
              this.letterNames[rowId] && this.letterNames[rowId][colId]
                ? this.letterNames[rowId][colId]
                : '+ Add Letter';
            if (letterName === '+ Add Letter') {
              allLettersSelected = false;
            }

            if (letterName !== '+ Add Letter') {
              const letterData = this.letterDataMap[letterName];

              payload.push({
                band: band,
                companyId: this.loggedInUserCompanyID,
                department: departmentData.department,
                fromYear: this.fromYear,
                id: null,
                letterCombination: 3,
                letterTemplateRequest: {
                  body: letterData?.body || '',
                  letterName: letterName,
                  subject: letterData?.subject || ''
                },
                ratingId: null,
                toYear: this.toYear
              });
            }
          });
        });

        const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
          disableClose: true,
          height: '30%',
          width: '30%',
          data: {
            msg: 'Increment letter successfully saved.',
            btn2: 'Done',
            btn2BgColor: this.buttonColorName,
            showSuccessIcon: false,
            showSuccessMessage: false,
            showCloseIcon: false
          },
        });

        dialogRef.afterClosed().subscribe((result: any) => {
          this.httpService
            .callPostService(this.config.setIncrementLettersForCombination, payload)
            .subscribe((result: any) => {
              if (result) {
                sessionStorage.removeItem('LettersName');
                this.getIncrementLettersCompanyData();
                this.getPromotionContent();
              }
            });
        });
      }




      // department and rating
      if (this.departmentChecked && this.ratingChecked && !this.bandChecked) {
        // const combinedData: any[] = [];
        // // let allLettersSelected = true;
        // this.getDeptAndRatingTableData.forEach((department: any, rowId: number) => {
        //   const lettersForDepartment = this.letterNames[rowId] || [];
        //   this.getRatingAndDeptTableData.forEach((rating: any, colId: number) => {
        //     const letterName = lettersForDepartment[colId] || '+ Add Letter';
        //     // Skip if letterName is "+ Add Letter"
        //     // if (letterName === '+ Add Letter') {
        //     //   allLettersSelected = false;
        //     //   return;
        //     // }
        //     const letterData = this.letterDataMap[letterName];    
        //     if (letterData) {
        //       combinedData.push({
        //         band: null,  
        //         companyId: this.loggedInUserCompanyID,
        //         department: department,
        //         fromYear: this.fromYear,
        //         id: letterData.id || null,  
        //         letterCombination: 4,  
        //         letterTemplateRequest: {
        //           body: letterData.body,
        //           letterName: letterName,
        //           subject: letterData.subject
        //         },
        //         toYear: this.toYear,
        //         ratingId: rating.id
        //       });
        //     }
        //   });
        // });

        // // If all letters are selected, trigger the dialog and API call
        // // if (allLettersSelected) {
        //   const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
        //     disableClose: true,
        //     height: '30%',
        //     width: '30%',
        //     data: {
        //       msg: 'Increment letter successfully saved.',
        //       btn2: 'Done',
        //       btn2BgColor: this.buttonColorName,
        //       showSuccessIcon: false,
        //       showSuccessMessage: false,
        //       showCloseIcon: false
        //     }
        //   });

        //   dialogRef.afterClosed().subscribe(() => {
        //     this.httpService.callPostService(this.config.setIncrementLettersForCombination, combinedData)
        //       .subscribe((response: any) => {
        //         sessionStorage.removeItem('LettersName');
        //         this.getIncrementLettersCompanyData();
        //         this.getPromotionContent();
        //       });
        //   });
        // // }
        const combinedData: any[] = [];
        this.getDepartmentTableData.forEach((department: any, rowId: number) => {
          const lettersForBand = this.letterNames[rowId] || [];
          this.getRatingTableData.forEach((rating: any, colId: number) => {
            const letterName = lettersForBand[colId] || '+ Add Letter';
            if (letterName === '+ Add Letter') {
              return;
            }
            const letterData = this.letterDataMap[letterName];
            if (letterData) {
              combinedData.push({
                band: null,
                companyId: this.loggedInUserCompanyID,
                department: department,
                fromYear: this.fromYear,
                id: null,
                letterCombination: 4,
                letterTemplateRequest: {
                  body: letterData.body,
                  letterName: letterName,
                  subject: letterData.subject
                },
                toYear: this.toYear,
                ratingId: rating.ratingId
              });
            }
          });
        });
        const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
          disableClose: true,
          height: '30%',
          width: '30%',
          data: {
            msg: 'Increment letter successfully saved.',
            btn2: 'Done',
            btn2BgColor: this.buttonColorName,
            showSuccessIcon: false,
            showSuccessMessage: false,
            showCloseIcon: false
          }
        });
        dialogRef.afterClosed().subscribe(() => {
          this.httpService.callPostService(this.config.setIncrementLettersForCombination, combinedData)
            .subscribe((response: any) => {
              if (response) {
                sessionStorage.removeItem('LettersName');
                this.getIncrementLettersCompanyData();
                this.getPromotionContent();
              }
            });
        });

      }


      // band and rating

      if (!this.departmentChecked && this.ratingChecked && this.bandChecked) {
        //   const combinedData:any = [];
        // let allLettersSelected = true;
        // this.getBandTableData.forEach((band: any, rowId: number) => {
        //   const lettersForDepartment = this.letterNames[rowId] || [];
        //   this.getRatingTableData.forEach((rating: any, colId: number) => {
        //     const letterName = lettersForDepartment[colId] || '+ Add Letter';
        //     const letterData = this.getIncrementLetterData.find(letter => letter.letterName === letterName);
        //     if (letterName === '+ Add Letter') {
        //       allLettersSelected = false;
        //     }
        //     combinedData.push({
        //       band: band,
        //       companyId: this.loggedInUserCompanyID,
        //       department: null,
        //       fromYear: this.fromYear,
        //       id: 0, 
        //       incrementLetterTemplateId: letterData ? {
        //         letterName: letterData.letterName,
        //         subject: letterData.subject,
        //         body: letterData.body
        //       } : null,
        //       toYear: this.toYear,
        //       ratingId: rating.id 
        //     });
        //   });
        // });

        // const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
        //   disableClose: true,
        //   height: '30%',
        //   width: '30%',
        //   data: {
        //     msg: 'Increment letter successfully saved.',
        //     btn2: 'Done',
        //     btn2BgColor: this.buttonColorName,
        //     showSuccessIcon: false,
        //     showSuccessMessage: false,
        //     showCloseIcon: false
        //   },
        // });
        // dialogRef.afterClosed().subscribe((result:any) => {
        //   this.httpService.callPostService(this.config.setIncrementLettersForCombination, combinedData)
        //   .subscribe((result: any)=>{});
        // });
        // const combinedData: any[] = [];
        //     let allLettersSelected = true;
        //     this.getBandTableData.forEach((band: any, rowId: number) => {
        //       const lettersForBand = this.letterNames[rowId] || [];
        //       this.getRatingTableData.forEach((rating: any, colId: number) => {
        //         const letterName = lettersForBand[colId] || '+ Add Letter';
        //         // if (letterName === '+ Add Letter') {
        //         //   allLettersSelected = false;
        //         // }
        //         const letterData = this.getIncrementLetterData.find(letter => letter.letterName === letterName);
        //         if (letterName !== '+ Add Letter' && letterData) {
        //           combinedData.push({
        //             band: band,
        //             companyId: this.loggedInUserCompanyID,
        //             department: null,
        //             fromYear: this.fromYear,
        //             id: letterData.id || null,   
        //             letterCombination: 5,
        //             letterTemplateRequest: {
        //               body: letterData.body, 
        //               letterName: letterName,
        //               subject: letterData.subject,
        //             },
        //             toYear: this.toYear,
        //             ratingId: rating.id,
        //           });
        //         }
        //       });
        //     });
        //      // if (allLettersSelected) {
        //       const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
        //         disableClose: true,
        //         height: '30%',
        //         width: '30%',
        //         data: {
        //           msg: 'Increment letter successfully saved.',
        //           btn2: 'Done',
        //           btn2BgColor: this.buttonColorName,
        //           showSuccessIcon: false,
        //           showSuccessMessage: false,
        //           showCloseIcon: false
        //         },
        //       });
        //       dialogRef.afterClosed().subscribe((result:any) => {
        //         this.httpService.callPostService(this.config.setIncrementLettersForCombination, combinedData)
        //         .subscribe((result: any)=>{
        //           this.getIncrementLettersCompanyData();
        //           this.getPromotionContent();
        //         });
        //       })

        const combinedData: any[] = [];
        this.getBandAndRatingTableData.forEach((band: any, rowId: number) => {
          const lettersForBand = this.letterNames[rowId] || [];
          this.getRatingAndBandTableData.forEach((rating: any, colId: number) => {
            const letterName = lettersForBand[colId] || '+ Add Letter';
            if (letterName === '+ Add Letter') {
              return;
            }
            const letterData = this.letterDataMap[letterName];
            if (letterData) {
              combinedData.push({
                band: band,
                companyId: this.loggedInUserCompanyID,
                department: null,
                fromYear: this.fromYear,
                id: null,
                letterCombination: 5,
                letterTemplateRequest: {
                  body: letterData.body,
                  letterName: letterName,
                  subject: letterData.subject
                },
                toYear: this.toYear,
                ratingId: rating.ratingId
              });
            }
          });
        });
        const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
          disableClose: true,
          height: '30%',
          width: '30%',
          data: {
            msg: 'Increment letter successfully saved.',
            btn2: 'Done',
            btn2BgColor: this.buttonColorName,
            showSuccessIcon: false,
            showSuccessMessage: false,
            showCloseIcon: false
          }
        });
        dialogRef.afterClosed().subscribe(() => {
          this.httpService.callPostService(this.config.setIncrementLettersForCombination, combinedData)
            .subscribe((response: any) => {
              sessionStorage.removeItem('LettersName');
              this.getIncrementLettersCompanyData();
              this.getPromotionContent();
            });
        });

      }

      if (this.departmentChecked && this.bandChecked && this.ratingChecked) {
        // const payload: any[] = [];
        // this.getDepartmentAndBandTableData.forEach((departmentData) => {
        //   const departmentName = departmentData.department;
        //   departmentData.bands.forEach((band: string) => {
        //     const rowId = this.getDepartmentAndBandTableData.indexOf(departmentData);
        //     const lettersForDepartment = this.letterNames[rowId] || [];
        //     this.getRatingTableData.forEach((rating: any, colId: number) => {
        //       const letterName = lettersForDepartment[colId];
        //       if (letterName && letterName !== '+ Add Letter') {
        //         const letterData = this.letterDataMap[letterName];
        //         payload.push({
        //           band: band,
        //           companyId: this.loggedInUserCompanyID,
        //           department: departmentName,
        //           fromYear: this.fromYear,
        //           id: letterData?.id || null,
        //           letterCombination: 6,
        //           letterTemplateRequest: letterData ? {
        //             body: letterData.body,
        //             letterName: letterName.toString(),
        //             subject: letterData.subject
        //           } : null,
        //           toYear: this.toYear,
        //           ratingId: rating.ratingId
        //         });
        //       }
        //     });
        //   });
        // });
        // const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
        //   disableClose: true,
        //   height: '30%',
        //   width: '30%',
        //   data: {
        //     msg: 'Increment letter successfully saved.',
        //     btn2: 'Done',
        //     btn2BgColor: this.buttonColorName,
        //     showSuccessIcon: false,
        //     showSuccessMessage: false,
        //     showCloseIcon: false,
        //   },
        // });

        // dialogRef.afterClosed().subscribe(() => {
        //   this.httpService.callPostService(this.config.setIncrementLettersForCombination, payload)
        //     .subscribe((result: any) => {
        //       if (result) {
        //         sessionStorage.removeItem('LettersName');
        //         this.getIncrementLettersCompanyData();
        //         this.getPromotionContent();
        //       }
        //     });
        // });

        const payload: any[] = [];

        this.getDepartmentAndBandTableData.forEach((departmentData, rowId) => {
          const departmentName = departmentData.department;

          departmentData.bands.forEach((band: any, bandIndex: any) => {
            const lettersForBand = this.letterNames[rowId]?.[bandIndex] || [];

            this.getRatingTableData.forEach((rating, colId) => {
              const letterName = lettersForBand[colId];

              if (letterName && letterName !== '+ Add Letter') {
                const letterData = this.letterDataMap[letterName];

                payload.push({
                  department: departmentName,
                  band: band,
                  companyId: this.loggedInUserCompanyID,
                  fromYear: this.fromYear,
                  toYear: this.toYear,
                  ratingId: rating.ratingId,
                  id: null,
                  letterCombination: 6,
                  letterTemplateRequest: letterData
                    ? {
                      body: letterData.body,
                      letterName: letterName.toString(),
                      subject: letterData.subject,
                    }
                    : null,
                });
              }
            });
          });
        });

        // Open the confirmation dialog and send the payload to the API
        const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
          disableClose: true,
          height: '30%',
          width: '30%',
          data: {
            msg: 'Increment letter successfully saved.',
            btn2: 'Done',
            btn2BgColor: this.buttonColorName,
            showSuccessIcon: false,
            showSuccessMessage: false,
            showCloseIcon: false,
          },
        });

        dialogRef.afterClosed().subscribe(() => {
          this.httpService.callPostService(this.config.setIncrementLettersForCombination, payload)
            .subscribe((result: any) => {
              if (result) {
                sessionStorage.removeItem('LettersName');
                this.getIncrementLettersCompanyData();
                this.getPromotionContent();
              }
            });
        });

      }
      this.setPromotionContent();
    }
  }
  setPromotionContent() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "fromYear": this.fromYear,
      "letterHeadUrl": null,
      "letterHeadUrlName": null,
      "promotionContent": this.IncrementLetterPromotionContent,
      "toYear": this.toYear
    }
    this.httpService.callPostService(this.config.setPromotionContent, request).subscribe((result: any) => { })
  }
  isHideCloseIcon: any = false;

  removeLetter(rowId: any, bandIndex: any, colId: any, letterNameToRemove: any): any {
    if (this.isDisabledIncrementLetter != true) {
      const letterID = this.letterDataMap[letterNameToRemove];
      this.letterNames[rowId][colId] = null;
      let letterNameArray: any = [];
      const lettersName = sessionStorage.getItem('LettersName');
      if (lettersName) {
        letterNameArray = JSON.parse(lettersName);
        const index = letterNameArray.indexOf(letterNameToRemove.toString());
        if (index) {
          letterNameArray.splice(index, 1);
          sessionStorage.setItem('LettersName', JSON.stringify(letterNameArray));
        }
      }
      if (this.letterNames[rowId] && Object.values(this.letterNames[rowId]).every((item: any) => item === null)) {
        delete this.letterNames[rowId];
      }
      if (this.letterNames[rowId] && this.letterNames[rowId][colId] === null) {
        delete this.letterNames[rowId][colId];
      }
      if (this.letterNames[rowId] && this.letterNames[rowId][bandIndex]) {
        this.letterNames[rowId][bandIndex][colId] = null;
        delete this.letterDataMap[letterNameToRemove];
      }
      this.getIncrementLetterData = [];
      setTimeout(() => {
        if (letterID) {
          this.httpService.callGetService(this.config.deleteIncrementLetterForCombination + letterID.id)
            .subscribe((result) => {
              if (result) {
                this.getIncrementLettersCompanyData();
              }
            });
        }
      }, 100);
    }
  }

  getIncrementLettersCompanyData() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "fromYear": this.fromYear,
      "toYear": this.toYear
    }
    this.httpService.callPostService(this.config.getIncrementLettersOfCompany, request).subscribe((result: any) => {
      sessionStorage.removeItem('LettersName');
      this.letterCombination = result?.data[0]?.letterCombination;

      this.departmentChecked = false;
      this.bandChecked = false;
      this.ratingChecked = false;

      this.onVisibleDepartmentData = false;
      this.onVisibleBandData = false;
      this.onVisibleRatingsData = false;
      this.onVisibleDepartmentAndBandData = false;
      this.onVisibleDepartmentAndRatingData = false;
      this.onVisibleBandAndRatingData = false;
      this.onVisibleDepartmentAndBandAndRatingData = false;

      // only department
      if (this.letterCombination == 0) {
        this.departmentChecked = true;
        this.getIncrementLetterData = [];
        this.getIncrementLetterTable();
        this.getDepartmentLetter(result);
      }

      // only band
      if (this.letterCombination == 1) {
        this.bandChecked = true;
        this.getIncrementLetterData = [];
        this.getIncrementLetterTable();
        this.getBandLetter(result);
      }

      // only rating
      if (this.letterCombination == 2) {
        this.ratingChecked = true;
        this.getIncrementLetterData = [];
        this.getIncrementLetterTable();
        this.getRatingLetter(result);
      }

      // only department and band
      if (this.letterCombination == 3) {
        this.departmentChecked = true;
        this.bandChecked = true;
        this.getIncrementLetterData = [];
        this.getIncrementLetterTable();
        this.getDepartmentAndBandLetter(result);
      }

      // only department and rating
      if (this.letterCombination == 4) {
        this.departmentChecked = true;
        this.ratingChecked = true;
        this.getIncrementLetterData = [];
        this.getIncrementLetterTable();
        this.getDepartmentAndRatingLetter(result);
      }

      // only band and rating
      if (this.letterCombination == 5) {
        this.bandChecked = true;
        this.ratingChecked = true;
        this.getIncrementLetterData = [];
        this.getIncrementLetterTable();
        this.getBandAndRatingLetter(result);
      }

      // only department and band and rating
      if (this.letterCombination == 6) {
        this.departmentChecked = true;
        this.bandChecked = true;
        this.ratingChecked = true;
        this.getIncrementLetterData = [];
        this.getIncrementLetterTable();
        this.getDeptAndBandAndRaingLetter(result);
      }
    })
    this.getPromotionContent()
  }

  // only department 
  getDepartmentLetter(result: any) {
    var letterNameArray: any[] = [];
    const lettersName = sessionStorage.getItem('LettersName');
    letterNameArray = lettersName ? JSON.parse(lettersName) : [];
    setTimeout(() => {
      result.data.forEach((item: any) => {
        const departmentIndex = this.getDepartmentTableData.indexOf(item.department);
        if (departmentIndex !== -1) {
          if (!this.letterNames[departmentIndex]) {
            this.letterNames[departmentIndex] = [];
          }
          this.letterNames[departmentIndex][0] = item.incrementLetterTemplateId.letterName;
          letterNameArray.push(item.incrementLetterTemplateId.letterName);
          sessionStorage.setItem('LettersName', JSON.stringify(letterNameArray));
          this.letterDataMap[item.incrementLetterTemplateId.letterName] = {
            id: item.id,
            subject: item.incrementLetterTemplateId.subject,
            body: item.incrementLetterTemplateId.body
          };
          this.getIncrementLetterData.push(item.incrementLetterTemplateId);
        }
      });
    }, 1000);
  }

  // only band 
  getBandLetter(result: any) {
    var letterNameArray: any[] = [];
    const lettersName = sessionStorage.getItem('LettersName');
    letterNameArray = lettersName ? JSON.parse(lettersName) : [];
    setTimeout(() => {
      result.data.forEach((item: any) => {
        const bandIndex = this.getBandTableData.indexOf(item.band);
        if (bandIndex !== -1) {
          if (!this.letterNames[bandIndex]) {
            this.letterNames[bandIndex] = [];
          }
          this.letterNames[bandIndex][0] = item.incrementLetterTemplateId.letterName;
          letterNameArray.push(item.incrementLetterTemplateId.letterName);
          sessionStorage.setItem('LettersName', JSON.stringify(letterNameArray));
          this.letterDataMap[item.incrementLetterTemplateId.letterName] = {
            id: item.id,
            subject: item.incrementLetterTemplateId.subject,
            body: item.incrementLetterTemplateId.body
          };
          this.getIncrementLetterData.push(item.incrementLetterTemplateId);
        }
      });
    }, 1000);
  }

  // only rating 
  getRatingLetter(result: any) {
    var letterNameArray: any[] = [];
    const lettersName = sessionStorage.getItem('LettersName');
    letterNameArray = lettersName ? JSON.parse(lettersName) : [];
    setTimeout(() => {
      this.letterNames = [];
      result.data.forEach((item: any) => {
        const ratingId = item.ratingId.id;
        const colId = this.getRatingTableData.findIndex(rating => rating.ratingId === ratingId);
        console.warn(colId);
        if (colId !== -1) {
          if (!this.letterNames[0]) {
            this.letterNames[0] = [];
          }
          this.letterNames[0][colId] = item.incrementLetterTemplateId.letterName;
          letterNameArray.push(item.incrementLetterTemplateId.letterName);
          sessionStorage.setItem('LettersName', JSON.stringify(letterNameArray));
          this.letterDataMap[item.incrementLetterTemplateId.letterName] = {
            id: item.id || null,
            subject: item.incrementLetterTemplateId.subject,
            body: item.incrementLetterTemplateId.body,
          };
          this.getIncrementLetterData.push(item.incrementLetterTemplateId);
        }
      });
    }, 1000);
  }

  // department and band 
  getDepartmentAndBandLetter(result: any) {
    var letterNameArray: any[] = [];
    const lettersName = sessionStorage.getItem('LettersName');
    letterNameArray = lettersName ? JSON.parse(lettersName) : [];
    setTimeout(() => {
      result.data.forEach((item: any) => {
        const departmentAndBandIndex = this.getDepartmentAndBandTableData.findIndex(
          (data: any) =>
            data.department === item.department && data.bands.includes(item.band)
        );
        if (departmentAndBandIndex !== -1) {
          if (!this.letterNames[departmentAndBandIndex]) {
            this.letterNames[departmentAndBandIndex] = new Array(
              this.getDepartmentAndBandTableData[departmentAndBandIndex].bands.length
            ).fill(null);
          }
          const bandIndex = this.getDepartmentAndBandTableData[departmentAndBandIndex].bands.indexOf(item.band);
          if (bandIndex !== -1) {
            this.letterNames[departmentAndBandIndex][bandIndex] = item.incrementLetterTemplateId.letterName;
            letterNameArray.push(item.incrementLetterTemplateId.letterName);
            sessionStorage.setItem('LettersName', JSON.stringify(letterNameArray));
            this.letterDataMap[item.incrementLetterTemplateId.letterName] = {
              id: item.id,
              subject: item.incrementLetterTemplateId.subject,
              body: item.incrementLetterTemplateId.body
            };
          }
          this.getIncrementLetterData.push(item.incrementLetterTemplateId);
        }
      });
    }, 1000);
  }

  // department and rating 
  getDepartmentAndRatingLetter(result: any) {
    var letterNameArray: any[] = [];
    const lettersName = sessionStorage.getItem('LettersName');
    letterNameArray = lettersName ? JSON.parse(lettersName) : [];
    setTimeout(() => {
      result.data.forEach((item: any) => {
        const departmentIndex = this.getDepartmentTableData.indexOf(item.department);
        const ratingIndex = this.getRatingTableData.findIndex((rating: any) => rating.ratingId === item.ratingId?.id);
        if (departmentIndex !== -1 && ratingIndex !== -1) {
          if (!this.letterNames[departmentIndex]) {
            this.letterNames[departmentIndex] = [];
          }
          this.letterNames[departmentIndex][ratingIndex] = item.incrementLetterTemplateId.letterName;
          letterNameArray.push(item.incrementLetterTemplateId.letterName);
          sessionStorage.setItem('LettersName', JSON.stringify(letterNameArray));
          this.letterDataMap[item.incrementLetterTemplateId.letterName] = {
            id: item.id,
            subject: item.incrementLetterTemplateId.subject,
            body: item.incrementLetterTemplateId.body
          };
        }
        this.getIncrementLetterData.push(item.incrementLetterTemplateId);
        this.letterDataMap[item.incrementLetterTemplateId.letterName] = {
          id: item.id,
          subject: item.incrementLetterTemplateId.subject,
          body: item.incrementLetterTemplateId.body
        };
      });
    }, 1000);
  }

  // band and rating 
  getBandAndRatingLetter(result: any) {
    var letterNameArray: any[] = [];
    const lettersName = sessionStorage.getItem('LettersName');
    letterNameArray = lettersName ? JSON.parse(lettersName) : [];
    setTimeout(() => {
      result.data.forEach((item: any) => {
        const departmentIndex = this.getBandAndRatingTableData.indexOf(item.band);
        const ratingIndex = this.getRatingAndBandTableData.findIndex((rating: any) => rating.ratingId === item.ratingId?.id);
        if (departmentIndex !== -1 && ratingIndex !== -1) {
          if (!this.letterNames[departmentIndex]) {
            this.letterNames[departmentIndex] = [];
          }
          this.letterNames[departmentIndex][ratingIndex] = item.incrementLetterTemplateId.letterName;
          letterNameArray.push(item.incrementLetterTemplateId.letterName);
          sessionStorage.setItem('LettersName', JSON.stringify(letterNameArray));
          this.letterDataMap[item.incrementLetterTemplateId.letterName] = {
            id: item.id,
            subject: item.incrementLetterTemplateId.subject,
            body: item.incrementLetterTemplateId.body
          };
        }
        this.getIncrementLetterData.push(item.incrementLetterTemplateId);
        this.letterDataMap[item.incrementLetterTemplateId.letterName] = {
          id: item.id,
          subject: item.incrementLetterTemplateId.subject,
          body: item.incrementLetterTemplateId.body
        };
      });
    }, 1000);
  }

  // department And band and rating 
  getDeptAndBandAndRaingLetter(result: any) {
    var letterNameArray: any[] = [];
    const lettersName = sessionStorage.getItem('LettersName');
    letterNameArray = lettersName ? JSON.parse(lettersName) : [];
    setTimeout(() => {
      result.data.forEach((item: any) => {
        const departmentAndBandIndex = this.getDepartmentAndBandTableData.findIndex(
          (data: any) => data.department === item.department && data.bands.includes(item.band)
        );
        const ratingIndex = this.getRatingTableData.findIndex(
          (rating: any) => rating.ratingId === item.ratingId?.id
        );
        if (departmentAndBandIndex !== -1 && ratingIndex !== -1) {
          const bandIndex = this.getDepartmentAndBandTableData[departmentAndBandIndex].bands.indexOf(item.band);
          if (!this.letterNames[departmentAndBandIndex]) {
            this.letterNames[departmentAndBandIndex] = [];
          }
          if (!this.letterNames[departmentAndBandIndex][bandIndex]) {
            this.letterNames[departmentAndBandIndex][bandIndex] = [];
          }
          this.letterNames[departmentAndBandIndex][bandIndex][ratingIndex] = item.incrementLetterTemplateId.letterName;
          letterNameArray.push(item.incrementLetterTemplateId.letterName);
          sessionStorage.setItem('LettersName', JSON.stringify(letterNameArray));
          this.letterDataMap[item.incrementLetterTemplateId.letterName] = {
            id: item.id,
            subject: item.incrementLetterTemplateId.subject,
            body: item.incrementLetterTemplateId.body
          };
          this.getIncrementLetterData.push(item.incrementLetterTemplateId);
        }
      });
    }, 1000);
  }
  getIncrementLetterTable() {
    // only Department
    if (this.departmentChecked && !this.bandChecked && !this.ratingChecked) {
      this.isIncrementLetterCreateContent = true;
      this.onVisibleDepartmentData = true;
      this.onVisibleBandData = false;
      this.onVisibleDepartmentAndBandData = false;
      this.onVisibleDepartmentAndRatingData = false;
      this.onVisibleBandAndRatingData = false;
      this.onVisibleDepartmentAndBandAndRatingData = false;
      this.onVisibleRatingsData = false;
      this.letterNames = [];
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "fetchBand": false,
        "fetchDepartment": true,
        "fromYear": this.fromYear,
        "toYear": this.toYear
      };
      this.httpService.callPostService(this.config.getIncrementLettersCombination, request).subscribe((result: any) => {
        this.getDepartmentTableData = result.data
      });
    }

    // only band
    if (this.bandChecked && !this.departmentChecked && !this.ratingChecked) {
      this.isIncrementLetterCreateContent = true;
      this.onVisibleDepartmentData = false;
      this.onVisibleBandData = true;
      this.onVisibleDepartmentAndBandData = false;
      this.onVisibleDepartmentAndRatingData = false;
      this.onVisibleBandAndRatingData = false;
      this.onVisibleDepartmentAndBandAndRatingData = false;
      this.onVisibleRatingsData = false;
      this.letterNames = [];
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "fetchBand": true,
        "fetchDepartment": false,
        "fromYear": this.fromYear,
        "toYear": this.toYear
      };
      this.httpService.callPostService(this.config.getIncrementLettersCombination, request).subscribe((result: any) => {
        this.getBandTableData = result.data;
      });
    }

    // only rating
    if (this.ratingChecked && !this.departmentChecked && !this.bandChecked) {
      this.isIncrementLetterCreateContent = true;
      this.onVisibleDepartmentData = false;
      this.onVisibleBandData = false;
      this.onVisibleDepartmentAndBandData = false;
      this.onVisibleDepartmentAndRatingData = false;
      this.onVisibleBandAndRatingData = false;
      this.onVisibleDepartmentAndBandAndRatingData = false;
      this.onVisibleRatingsData = true;
      this.letterNames = [];
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "fromYear": this.fromYear,
        "toYear": this.toYear
      }
      this.httpService.callPostService(this.config.getScoreToRatingConverter, request).subscribe((result: any) => {
        this.getRatingTableData = result.data.map((ele: any) => ({
          rating: ele.rating,
          ratingId: ele.id,
        }));
      })
    }

    // department and band
    if (this.departmentChecked && this.bandChecked && !this.ratingChecked) {
      this.isIncrementLetterCreateContent = true;
      this.onVisibleDepartmentData = false;
      this.onVisibleBandData = false;
      this.onVisibleDepartmentAndBandData = true;
      this.onVisibleDepartmentAndRatingData = false;
      this.onVisibleBandAndRatingData = false;
      this.onVisibleDepartmentAndBandAndRatingData = false;
      this.onVisibleRatingsData = false;
      this.letterNames = [];
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "fetchBand": true,
        "fetchDepartment": true,
        "fromYear": this.fromYear,
        "toYear": this.toYear
      };
      this.httpService.callPostService(this.config.getIncrementLettersCombination, request).subscribe((result: any) => {
        this.getDepartmentAndBandTableData = result.data;
        this.onVisibleDepartmentAndBandAndRatingData = false;
      });

    }

    // department and rating
    if (this.departmentChecked && this.ratingChecked && !this.bandChecked) {
      this.isIncrementLetterCreateContent = true;
      this.onVisibleDepartmentData = false;
      this.onVisibleBandData = false;
      this.onVisibleDepartmentAndBandData = false;
      this.onVisibleDepartmentAndRatingData = true;
      this.onVisibleBandAndRatingData = false;
      this.onVisibleDepartmentAndBandAndRatingData = false;
      this.onVisibleRatingsData = false;
      this.letterNames = [];
      const getdepartmentrequest = {
        "companyId": this.loggedInUserCompanyID,
        "fetchBand": false,
        "fetchDepartment": true,
        "fromYear": this.fromYear,
        "toYear": this.toYear
      };
      this.httpService.callPostService(this.config.getIncrementLettersCombination, getdepartmentrequest).subscribe((result: any) => {
        this.getDepartmentTableData = result.data
      });

      const getRatingrequest = {
        "companyId": this.loggedInUserCompanyID,
        "fromYear": this.fromYear,
        "toYear": this.toYear
      }
      this.httpService.callPostService(this.config.getScoreToRatingConverter, getRatingrequest).subscribe((result: any) => {
        this.getRatingTableData = result.data.map((ele: any) => ({
          rating: ele.rating,
          ratingId: ele.id,
        }));
      })
    }

    // band and rating
    if (this.bandChecked && this.ratingChecked && !this.departmentChecked) {
      this.isIncrementLetterCreateContent = true;
      this.onVisibleDepartmentData = false;
      this.onVisibleBandData = false;
      this.onVisibleDepartmentAndBandData = false;
      this.onVisibleDepartmentAndRatingData = false;
      this.onVisibleBandAndRatingData = true;
      this.onVisibleDepartmentAndBandAndRatingData = false;
      this.onVisibleRatingsData = false;
      this.letterNames = [];
      const getBandrequest = {
        "companyId": this.loggedInUserCompanyID,
        "fetchBand": true,
        "fetchDepartment": false,
        "fromYear": this.fromYear,
        "toYear": this.toYear
      };
      this.httpService.callPostService(this.config.getIncrementLettersCombination, getBandrequest).subscribe((result: any) => {
        this.getBandAndRatingTableData = result.data;
      });
      const getRatingrequest = {
        "companyId": this.loggedInUserCompanyID,
        "fromYear": this.fromYear,
        "toYear": this.toYear
      }
      this.httpService.callPostService(this.config.getScoreToRatingConverter, getRatingrequest).subscribe((result: any) => {
        this.getRatingAndBandTableData = result.data.map((ele: any) => ({
          rating: ele.rating,
          ratingId: ele.id,
        }));
      })
    }

    // department and band and rating
    if (this.departmentChecked && this.bandChecked && this.ratingChecked) {
      this.isIncrementLetterCreateContent = true;
      this.onVisibleDepartmentData = false;
      this.onVisibleBandData = false;
      this.onVisibleDepartmentAndBandData = false;
      this.onVisibleDepartmentAndRatingData = false;
      this.onVisibleBandAndRatingData = false;
      this.onVisibleDepartmentAndBandAndRatingData = true;
      this.onVisibleRatingsData = false;
      this.letterNames = [];
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "fetchBand": true,
        "fetchDepartment": true,
        "fromYear": this.fromYear,
        "toYear": this.toYear
      };
      this.httpService.callPostService(this.config.getIncrementLettersCombination, request).subscribe((result: any) => {
        this.getDepartmentAndBandTableData = result.data;
      });
      const getRatingrequest = {
        "companyId": this.loggedInUserCompanyID,
        "fromYear": this.fromYear,
        "toYear": this.toYear
      }
      this.httpService.callPostService(this.config.getScoreToRatingConverter, getRatingrequest).subscribe((result: any) => {
        this.getRatingTableData = result.data.map((ele: any) => ({
          rating: ele.rating,
          ratingId: ele.id,
        }));
      })
    }

    if (!this.departmentChecked && !this.bandChecked && !this.ratingChecked) {
      this.onVisibleDepartmentData = false;
      this.onVisibleBandData = false;
      this.onVisibleDepartmentAndBandData = false;
      this.onVisibleRatingsData = false;
      this.onVisibleDepartmentAndBandAndRatingData = false;
    }
  }

  getPromotionContent() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "fromYear": this.fromYear,
      "toYear": this.toYear
    }
    this.httpService.callPostService(this.config.getIncrementSetupByYear, request).subscribe((result: any) => {
      this.IncrementLetterPromotionContent = result.data.promotionContent
    })
  }
}